export default __webpack_public_path__ + "static/media/DinosaursCarnivores_02.4115be47.png";